// CONVENTION formatFoo -> string

import { ethers } from "ethers";
import { getAddress } from "@ethersproject/address";
import Numeral from "numeral";

export const formatBalance = (
  value: ethers.BigNumberish,
  decimals = 18,
  maxFraction = 0
) => {
  const formatted = ethers.utils.formatUnits(value, decimals);
  if (maxFraction > 0) {
    const split = formatted.split(".");
    if (split.length > 1) {
      return split[0] + "." + split[1].substr(0, maxFraction);
    }
  }
  return formatted;
};

export function shortenAddress(address: string, chars = 4): string {
  try {
    const parsed = getAddress(address);
    return `${parsed.substring(0, chars + 2)}...${parsed.substring(
      42 - chars
    )}`;
  } catch (error) {
    throw Error(`Invalid 'address' parameter '${address}'.`);
  }
}

export function numberWithCommas(x: string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// export function timeFromEpoch(utcEpochSecods: string) {
//   const d = new Date(0);
//   d.setUTCSeconds(Number(utcEpochSecods));
//   return d.toDateString();
// }
// export function timeFromEpoch(utcEpochSeconds: string) {
//   const d = new Date(0);
//   d.setUTCSeconds(Number(utcEpochSeconds));

//   const options: any = { day: '2-digit', month: 'short', year: 'numeric' };
//   return d.toLocaleDateString(undefined, options);
// }

export function timeFromEpoch(utcEpochSeconds: string) {
  const d = new Date(0);
  d.setUTCSeconds(Number(utcEpochSeconds));

  // Extracting individual date components
  const day = d.getUTCDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' });
  const year = d.getUTCFullYear();

  return `${day} ${month}, ${year}`;
}

export function dateTimeFromEpoch(utcEpochSeconds: string) {
  const d = new Date(0);
  d.setUTCSeconds(Number(utcEpochSeconds));

  // Extracting individual date components
  const hours = d.getUTCHours().toString().padStart(2, '0');
  const minutes = d.getUTCMinutes().toString().padStart(2, '0');
  const day = d.getUTCDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' });
  const year = d.getUTCFullYear();

  return `${hours}:${minutes} UTC | ${day} ${month}, ${year}`;
}

export function convertTimeToMili(sc: string | number) {
  const d = new Date(0);
  d.setUTCSeconds(Number(sc));
  return d.getTime();
}

export const convertSecToDate = (sec) => {
  const time = sec / (24 * 60 * 60);
  const result = time < 1 ? sec / (60 * 60) : time;
  const isHours = sec / (24 * 60 * 60) < 1 && time !== 0;
  return [result, isHours];
};

export const checkDecimals = (num: number, decimals: number) => {
  const numArr = num.toString().split(".");
  const lengthDecimal = numArr[1]?.length || 0;
  return lengthDecimal === 2;
};

export const formatK = (value: string) => {
  return Numeral(value).format("0.[00]a");
};

const priceFormatter = (decimals) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
  });

export const formatNumber = (
  number: any,
  usd = false,
  loading = false,
  scale = false,
  decimals = 5
) => {
  if (loading) {
    return "--";
  }
  if (isNaN(number) || number === "" || number === undefined) {
    return "--";
  }

  if (Number(number) < 0.00001 && Number(number) > 0) {
    return usd ? "< $0.00001" : "< 0.00001";
  }
  const num = checkDecimals(number, decimals)
    ? number
    : Math.trunc(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

  if (num > 500000000 && scale) {
    return (usd ? "$" : "") + formatK(num.toFixed(decimals));
  }

  if (num === 0) {
    if (usd) {
      return "$0";
    }
    return "0";
  }

  if (num >= 1000 || num <= -1000) {
    const usdString = priceFormatter(decimals).format(num);
    return (
      (num >= 1000 ? "" : "-") +
      (usd ? "$" : "") +
      usdString.slice(1, usdString.length)
    );
  }

  if (usd) {
    if (num < 0.1) {
      return "$" + Number(parseFloat(String(num)).toFixed(decimals));
    } else {
      const usdString = priceFormatter(decimals).format(num);
      return "$" + usdString.slice(1, usdString.length);
    }
  }

  return parseFloat(String(num)).toFixed(decimals);
};

export const convertDurationToDate = (duration: string) => {
  const [result, isHours] = convertSecToDate(duration);
  return result === 0 && !isHours
    ? "No lock-up"
    : `${result}-${isHours ? "hour" : "days"} `;
};

